/**
 * Better Auth React Client
 * Frontend authentication client for React applications
 */

import { createAuthClient } from "better-auth/react";

// AUTH_CLIENT: Better Auth React client -> Related: AuthContext.tsx, auth.ts
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:8787",
});

// Export commonly used methods for convenience
export const { signIn, signUp, signOut, useSession, getSession } = authClient;

// Type exports for use in components
export type Session = typeof authClient.$Infer.Session;
export type User = Session["user"];
